export const getMessage = () => {
    return fetch('/customers/get-payment-action-required-message/');
};
